module.exports = __webpack_public_path__ + "img/bravo.eb887320.jpg";